import { Form } from 'factorial-form'

export class ClockPicturesConfigFilters extends Form {
  constructor(values: object) {
    super(values, {
      status: 'string',
    })
  }
}
